export default {
  contractMission: {
    contractMission: {
      title: ({ plural }) => plural(["Mission", "Missions"]),
      aiProposal: "Proposition IA",
      activitiesLinked: ({ named }) => `${named("count")} activité(s) rattachée(s)`,
      levelOfAchievement: "Niveau de réalisation",
      validate: "Valider cette mission",
      decline: "Refuser",
      merge: "Fusionner dans...",
      defined: "Missions définies",
      no_missions: "Aucune mission n'est définie sur ce contrat.",
      import: "Importer la fiche de mission",
      import_from_sheet: "Commencer à en ajouter à partir d'une fiche mission",
      empty_no_sheet:
        "Aucune mission n'est définie. Importez une fiche de mission pour démarrer le suivi de l'alternant.",
      empty_no_sheet_no_ia: "Aucune mission n'est définie.",
      empty_no_sheet_cta: "Importer une fiche de mission",
      empty_has_sheet:
        "Une fiche de mission a été importée. Lancez le découpage pour transformer son contenu en missions à suivre.",
      empty_has_sheet_cta: "Lancer le découpage",
      no_ia_alert: "Définissez et suivez les missions de votre alternant/stagiaire dans cet onglet",
      no_ia_alert_description: "Ajouter une mission pour votre alternant/stagiaire",
    },
    import: {
      title: "Découpage de la fiche de mission",
      intro: "L'IA identifie et reformule les missions de la fiche — vous choisissez celles à publier.",
      existing_sheet: "Fiche de mission",
      upload_pdf: "Déposer un PDF",
      free_text: "Ou saisir le contenu directement",
      free_text_placeholder: "Collez ou saisissez le contenu de votre fiche de mission…",
      or: "ou",
      or_replace: "ou déposer une autre fiche",
      has_file_alert: "Fiche importée depuis le dossier d'inscription",
      split_failed: "Le découpage automatique n'a pas fonctionné. Veuillez relancer le découpage.",
      launch: "Lancer le découpage",
      loading_title: "Découpage en cours...",
      loading_subtitle: "L'IA analyse et reformule les missions",
      missions_proposed: "mission(s) proposée(s)",
      validate_all: "Tout valider",
      results_actions: "Actions sur les missions proposées",
      validate: "Valider",
      edit: "Modifier",
      remove: "Supprimer",
      confirm_edit: "Confirmer la modification",
      field_name: "Nom de la mission",
      field_description: "Description de la mission",
      no_missions: "Aucune mission proposée.",
      publish: ({ named }) => `Publier ${named("count")} mission(s)`,
      publish_success: ({ named }) => `${named("count")} mission(s) publiée(s) avec succès`,
      removal_announcement: ({ named }) =>
        `Mission « ${named("name")} » supprimée. ${named("count")} mission(s) proposée(s) restante(s).`,
    },
    banner: {
      title: "Une fiche de mission a été importée depuis le dossier d'inscription",
      subtitle:
        "Découpez cette fiche en missions pour suivre la progression de l'alternant tout au long de l'alternance",
      import: "Procéder à l'import",
      import_tooltip: "Ouvrir la modale de découpage de la fiche de mission",
      later: "Plus tard",
      later_tooltip: "Masquer ce bandeau pour cette session",
    },
  },
};
